






















import Vue from 'vue'

export default Vue.extend({
  methods: {
    openLandingModal(): void {
      this.$emit('openLandingModal')
    }
  }
})
